import GoogleSansFlexVariable from './GoogleSansFlex/GoogleSansFlex-Variable.woff2';
import InterVariable from './Inter/Inter-Variable.woff2';

/**
 * The family names the two faces are declared under in `./fonts.css`, and the file behind each.
 *
 * Everything that renders in the browser reaches the faces through CSS — the `@font-face` rules in
 * `./fonts.css`, and `font-family` from either the MUI theme or the `html` rules there. This module
 * exists for the ONE consumer that cannot: `useExportAsPNG` renders through html2canvas, which
 * paints text onto a canvas and therefore needs the font bytes inlined as a data URL rather than a
 * stylesheet it can follow.
 *
 * That requirement is also why nine static Inter `.ttf` files used to sit in this directory — they
 * were added for the PNG export in `22726eb5d` and never served the page, which went to Google
 * Fonts over the network instead. One variable woff2 per face now does both jobs.
 */
export const FONT_FAMILY = {
  inter: 'Inter',
  googleSansFlex: 'Google Sans Flex',
} as const;

export type FontFamily = (typeof FONT_FAMILY)[keyof typeof FONT_FAMILY];

/** Weight range of each variable face, as declared in `./fonts.css`. */
export const FONT_WEIGHT_RANGE: Record<FontFamily, string> = {
  [FONT_FAMILY.inter]: '100 900',
  [FONT_FAMILY.googleSansFlex]: '1 1000',
};

export const FONT_FILE: Record<FontFamily, string> = {
  [FONT_FAMILY.inter]: InterVariable,
  [FONT_FAMILY.googleSansFlex]: GoogleSansFlexVariable,
};
